import Statistic from './index'
import Daily from './daily'
import Plan from './plan'
import Labor from './labor'

export default [
  {
    path: '/statistics',
    component: Statistic
  },
  {
    path: '/statistics/daily',
    component: Daily
  },
  {
    path: '/statistics/plan',
    component: Plan
  },
  {
    path: '/statistics/labor',
    component: Labor
  },
]
